import Img from "../../assets/img/avitoStep1.png";
import Img2 from "../../assets/img/avitoStep2.png";
import Img3 from "../../assets/img/avitoStep31.png";
import Img31 from "../../assets/img/avitoStep3.png";

import styles from "../../ui/Tooltip/Tooltip.module.scss";

export const stepsDataAvitoClientId = [
  {
    title: "Найдите раздел “Для профессионалов",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Откройте сайт Авито в браузере.</li>
        <li>Войдите в свой аккаунт, используя логин и пароль.</li>
        <li>
          После авторизации перейдите в свой профиль и обратите внимание на
          левое меню.
        </li>
        <li>В списке найдите пункт “Для профессионалов” и кликните на него.</li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Перейдите в раздел “Интеграции”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В открывшемся блоке выберите раздел “Интеграции”.</li>
        <li>Нажмите на этот пункт, чтобы открыть настройки интеграций.</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Скопируйте ключ интеграции",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Найдите поле с вашим ключом Client_id.</li>
        <li>Скопируйте его и вставьте в поле ввода.</li>
      </ul>
    ),
    imgSrc: Img3,
  },
];

export const stepsDataAvitoClientSecret = [
  {
    title: "Найдите раздел “Для профессионалов",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Откройте сайт Авито в браузере.</li>
        <li>Войдите в свой аккаунт, используя логин и пароль.</li>
        <li>
          После авторизации перейдите в свой профиль и обратите внимание на
          левое меню.
        </li>
        <li>В списке найдите пункт “Для профессионалов” и кликните на него.</li>
      </ul>
    ),
    imgSrc: Img,
  },
  {
    title: "Перейдите в раздел “Интеграции”",
    description: (
      <ul className={styles.ulListContainer}>
        <li>В открывшемся блоке выберите раздел “Интеграции”.</li>
        <li>Нажмите на этот пункт, чтобы открыть настройки интеграций.</li>
      </ul>
    ),
    imgSrc: Img2,
  },
  {
    title: "Скопируйте ключ интеграции",
    description: (
      <ul className={styles.ulListContainer}>
        <li>Найдите поле с вашим ключом Client_secret.</li>
        <li>Скопируйте его и вставьте в поле ввода.</li>
      </ul>
    ),
    imgSrc: Img31,
  },
];
